<form
  [formGroup]="formGroup"
  class="tw-mt-7.5 tw-flex tw-w-full tw-max-w-[340px] tw-flex-col tw-border tw-border-geyser tw-p-5"
>
  <div class="tw-flex tw-w-full tw-justify-between">
    <label
      id="label-inheritance-information-inheritance"
      for="btn-remove-inheritance-information"
      class="tw-font-sans tw-text-lg tw-font-semibold"
    >
      {{ title }}
    </label>
    @if (removable) {
      <div class="tw-flex tw-items-center tw-justify-center">
        <button
          (click)="onRemove()"
          class="tw-font-sans tw-text-base tw-font-semibold tw-text-sea-green tw-underline"
          data-test-id="btn-remove-inheritance-information"
          id="btn-remove-inheritance-information"
          type="button"
        >
          {{ 'screens.inheritanceInformation.information.button.remove' | translate }}
        </button>
        <ia-icons name="circle_xmark" color="#00915A" class="tw-ml-2.5 tw-size-4.5" />
      </div>
    }
  </div>
  <div class="tw-mt-7.5">
    <label
      class="tw-font-sans tw-text-base tw-font-semibold"
      id="label-inheritance-information-gender"
      for="input-inheritance-information-genders"
    >
      {{ 'screens.inheritanceInformation.information.gender.label' | translate }}
      @if (!formGroup.controls.gender.hasValidator(requiredValidator)) {
        {{ 'screens.inheritanceInformation.information.optional' | translate }}
      }
    </label>
    @for (object of genders$ | async; track $index) {
      <ia-radio-button
        aria-describedby="gender"
        class="first-letter:tw-uppercase"
        type="radio"
        [value]="object.value"
        groupName="gender"
        formControlName="gender"
      >
        {{ object.label }}
      </ia-radio-button>
    }
    @if (formGroup.controls.gender.touched && formGroup.controls.gender.invalid) {
      <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
        {{ 'screens.inheritanceInformation.information.name.error' | translate }}
      </p>
    }
  </div>
  <div class="tw-mt-7.5">
    <label
      class="tw-font-sans tw-text-base tw-font-semibold"
      id="label-reporter-inheritance-name"
      for="input-reporter-inheritance-name"
      >{{ 'screens.inheritanceInformation.information.name.label' | translate }}
      @if (!formGroup.controls.name.hasValidator(requiredValidator)) {
        {{ 'screens.inheritanceInformation.information.optional' | translate }}
      }
    </label>
    <input
      [patterns]="numbersAndSpecialCharactersNotAllowed"
      [error]="formGroup.controls.name.touched && formGroup.controls.name.invalid"
      iaInput
      class="tw-w-75"
      formControlName="name"
      id="input-reporter-inheritance-name"
      data-test-id="input-reporter-inheritance-name"
      mask="A*"
      [specialCharacters]="[' -', 'space']"
      maxlength="32"
    />
    @if (formGroup.controls.name.touched && formGroup.controls.name.invalid) {
      <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
        {{ 'screens.inheritanceInformation.information.name.error' | translate }}
      </p>
    }
  </div>
  <div class="tw-mt-7.5">
    <label
      class="tw-font-sans tw-text-base tw-font-semibold"
      id="label-reporter-inheritance-firstname"
      for="input-reporter-inheritance-firstname"
      >{{ 'screens.inheritanceInformation.information.firstname.label' | translate }}
      @if (!formGroup.controls.firstname.hasValidator(requiredValidator)) {
        {{ 'screens.inheritanceInformation.information.optional' | translate }}
      }
    </label>
    <input
      [patterns]="numbersAndSpecialCharactersNotAllowed"
      [error]="formGroup.controls.firstname.touched && formGroup.controls.firstname.invalid"
      iaInput
      class="tw-w-75"
      formControlName="firstname"
      id="input-reporter-inheritance-firstname"
      data-test-id="input-reporter-inheritance-firstname"
      mask="A*"
      [specialCharacters]="[' -', 'space']"
      maxlength="32"
    />
    @if (formGroup.controls.firstname.touched && formGroup.controls.firstname.invalid) {
      <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
        {{ 'screens.inheritanceInformation.information.firstname.error' | translate }}
      </p>
    }
  </div>
  <div class="tw-mt-7.5">
    <label
      class="tw-font-sans tw-text-base tw-font-semibold"
      id="label-inheritance-information-email"
      for="input-inheritance-information-email"
    >
      {{ 'screens.inheritanceInformation.information.email.label' | translate }}
    </label>

    <input
      iaInput
      class="tw-w-75"
      formControlName="email"
      id="input-inheritance-information-email"
      data-test-id="input-inheritance-information-email"
      maxlength="100"
      name="email"
    />
    @if (formGroup.controls.email.touched && formGroup.controls.email.invalid) {
      <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
        {{ 'screens.inheritanceInformation.information.email.error' | translate }}
      </p>
    }
  </div>
  <div class="tw-mt-7.5">
    <label
      class="tw-font-sans tw-text-base tw-font-semibold"
      id="label-inheritance-information-phone"
      for="input-inheritance-information-phoneNumber"
      >{{ 'screens.inheritanceInformation.information.phoneNumber.label' | translate }}</label
    >

    <input
      iaInput
      class="tw-w-75"
      id="input-inheritance-information-phoneNumber"
      data-test-id="input-inheritance-information-phoneNumber"
      maxlength="20"
      formControlName="phoneNumber"
    />
  </div>
  <div class="tw-mt-7.5">
    <label
      class="tw-font-sans tw-text-base tw-font-semibold"
      id="label-inheritance-information-address"
      for="input-inheritance-information-address"
      >{{ 'screens.inheritanceInformation.information.address.label' | translate }}</label
    >
    <input
      [patterns]="specialCharactersNotAllowed"
      iaInput
      class="tw-w-75"
      formControlName="address"
      id="input-inheritance-information-address"
      data-test-id="input-inheritance-information-address"
      mask="A*"
      [specialCharacters]="[' -', 'space']"
      maxlength="50"
      name="address"
    />
  </div>
  <div class="tw-mt-7.5">
    <label
      class="tw-font-sans tw-text-base tw-font-semibold"
      for="input-inheritance-information-additional-address"
      id="label-inheritance-information-additional-address"
      >{{
        'screens.inheritanceInformation.information.complementaryAddress.label' | translate
      }}</label
    >
    <input
      [patterns]="specialCharactersNotAllowed"
      iaInput
      class="tw-w-75"
      id="input-inheritance-information-additional-address"
      data-test-id="input-inheritance-information-additional-address"
      mask="A*"
      [specialCharacters]="[' -', 'space']"
      maxlength="50"
      formControlName="complementaryAddress"
      name="complementaryAddress"
    />
  </div>
  <div class="tw-mt-7.5">
    <div class="tw-flex-row">
      <label
        class="tw-font-sans tw-text-base tw-font-semibold"
        for="input-inheritance-information-zip-code"
        id="label-inheritance-information-zip-code"
        >{{ 'screens.inheritanceInformation.information.zipcode.label' | translate }}</label
      >
    </div>
    <input
      class="tw-w-75"
      formControlName="zipcode"
      iaInput
      id="input-inheritance-information-zip-code"
      data-test-id="input-inheritance-information-zip-code"
      maxlength="32"
      name="zipcode"
    />
  </div>
  <div class="tw-mt-7.5">
    <div class="tw-flex-row">
      <label
        class="tw-font-sans tw-text-base tw-font-semibold"
        id="label-inheritance-information-city"
        for="input-inheritance-information-city"
        >{{ 'screens.inheritanceInformation.information.city.label' | translate }}</label
      >
    </div>
    <input
      [patterns]="numbersAndSpecialCharactersNotAllowed"
      class="tw-w-75"
      formControlName="city"
      iaInput
      id="input-inheritance-information-city"
      data-test-id="input-inheritance-information-city"
      mask="A*"
      [specialCharacters]="[' -', 'space']"
      maxlength="32"
      name="city"
    />
  </div>
  <div class="tw-mt-7.5">
    <div class="tw-flex-row">
      <label
        class="tw-font-sans tw-text-base tw-font-semibold"
        id="label-inheritance-information-country"
        for="input-inheritance-information-country"
      >
        {{ 'screens.inheritanceInformation.information.country.label' | translate }}
      </label>
    </div>
    <div class="tw-mt-2.5">
      <ia-listbox2
        formControlName="country"
        [overlayOverrides]="listBoxOverlayConfig"
        class="tw-w-75"
        triggerId="input-inheritance-information-country"
        triggerAriaLabelledBy="label-inheritance-information-country"
      >
        <div *iaListbox2Placeholder>
          {{ 'screens.notaryInformation.information.country.placeholder' | translate }}
        </div>

        @for (option of (countries$ | async) || []; track option.value) {
          <ia-listbox2-option [value]="option.value">
            {{ option.label }}
          </ia-listbox2-option>
        }
      </ia-listbox2>
    </div>
  </div>
</form>
